import { OENLoadingOutcome } from "../enums/oe-loading-outcome.enum";
import { OENEntryType } from "../enums/oe-entry-type.enum";

export class OELoadingResponseModel {
  public outcome: OENLoadingOutcome;
  public message: string;
  public rootRefId: string;
  public refId: string;
  public entryType: OENEntryType;

  constructor(
    _outcome: OENLoadingOutcome,

    _message: string = null,
    _rootRefId: string = null,
    _refId: string = null,
    _entryType: OENEntryType = null,
  ) {
    this.outcome = _outcome;
    this.entryType = _entryType;
    this.message = _message;
    this.refId = _refId;
    this.rootRefId = _rootRefId;
  }
}
